<template>
    <button :class="{fill: button.fill, disabled: button.disabled || disabled, outlined:button.outlined}">
        <i v-if="button.icon" :class="`fas fa-${button.icon}`"></i>
        <span v-text="button.display"></span>
    </button>
</template>

<script>
export default {
    name: 'ButtonCenter',
    props: ['button', 'disabled']
}
</script>
<style lang="less" scoped>
    button {
        display: block;
        margin: auto;
        width: 100%;
        padding: 15px 10px;
        margin-bottom: 15px;
        border: none;
        background-color: var(--buttonBackground);
        font-size: 1.11rem;
        color: var(--buttonText);
        border-radius: 5px;
        i {
            color: var(--buttonText);
            margin: 0 0 0 -15px;
            padding-right: 15px;
        }
        &.fill {
            background: var(--buttonBackground);
            color: var(--buttonText);
        }
        &.disabled {
            background: whitesmoke;
            color: black;
            pointer-events: none;
        }
        &.outlined {
            background: var(--buttonBackground);
            color: var(--buttonText);
            border: solid 2px var(--primaryColor);
        }
    }
</style>
